// extracted by mini-css-extract-plugin
export default {"nutritionDisplay":"NutritionDisplay_nutritionDisplay__dvSQy","nutritionValue":"NutritionDisplay_nutritionValue__OthBy"};